import { render, staticRenderFns } from "./LaudoAvaliacaoSocioambiental.vue?vue&type=template&id=b4541be0&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoSocioambiental.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoSocioambiental.vue?vue&type=style&index=0&id=b4541be0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4541be0",
  null
  
)

export default component.exports